export const guestWithdrawalsQuerySelect = (state) =>
  state.payment.guests?.withdrawals?.fetch;

export const guestWithdrawBalanceMutationSelect = (state) =>
  state.payment.guests?.withdrawals?.post;

export const guestPaymentDetailsQuerySelect = (state) =>
  state.payment.guests?.payments;
